<template>
  <ul>
    <NavigationEntry
      v-for="item in items"
      :key="item.name"
      :show-pin="false"
      :item="item"
    />
  </ul>
</template>

<script>
import NavigationEntry from 'src/components/navigation/navigation_entry.vue'

import { useFollowedTagsStore } from 'src/stores/followed_tags.js'

// The followed hashtags as entries of the navigation panel.
export default {
  components: { NavigationEntry },
  computed: {
    items() {
      return useFollowedTagsStore().tags.map((tag) => ({
        name: `tag-${tag.name}`,
        routeObject: { name: 'tag-timeline', params: { id: tag.name } },
        labelRaw: `#${tag.name}`,
        iconLetter: '#',
      }))
    },
  },
}
</script>
